import React from 'react';
import { Link } from 'react-router-dom';
import ProductShell from '../marketing/ProductShell';
import FeaturesJourneyTimeline from '../marketing/FeaturesJourneyTimeline';
import PageMeta from '../seo/PageMeta';

const FeaturesPage = () => (
  <ProductShell
    title="Product tour — your journey"
    eyebrow="Features"
    lead="Walk through QnaRead in the order learners use it: import and build notebooks, search the library, then practice and review until knowledge sticks."
    ctaLabel="Sign in to try it"
    ctaRedirect="/dashboard"
  >
    <PageMeta
      description="Timeline of the QnaRead learner journey: Notebook hub, Library, Study hub, practice, spaced review, AI explain, analytics, sharing, and Teams."
    />
    <FeaturesJourneyTimeline />

    <section className="features-journey-footer" aria-labelledby="features-journey-footer-heading">
      <h2 id="features-journey-footer-heading">Compare plans &amp; dive deeper</h2>
      <p>
        Every step above maps to a live area of the app after sign-in. See exact limits per plan on{' '}
        <Link to="/pricing">Pricing</Link> or the feature matrix on{' '}
        <Link to="/product">Product</Link>.
      </p>
      <div className="marketing-hero-actions features-journey-footer-actions">
        <Link to="/product" className="marketing-btn marketing-btn-secondary">
          Product overview
        </Link>
        <Link to="/pricing" className="marketing-btn marketing-btn-secondary">
          Compare plans
        </Link>
      </div>
    </section>
  </ProductShell>
);

export default FeaturesPage;
